import { BaseModel } from "model/BaseModel";
import Viagem from "./Viagem";
import ViagemTipoDespesa from "./ViagemTipoDespesa";
import Arquivo from "model/arquivo/Arquivo";
import ViagemDespesaAprovacao from "./ViagemDespesaAprovacao";

export default class ViagemDespesa implements BaseModel {
    id: number | null;
    codigo: string | null;
    viagem: Viagem | null;
    tipo: ViagemTipoDespesa | null;
    dataDespesa: Date | null;
    observacao: string;
    imagens: Arquivo[];
    valor: number;
    valorAlerta: number | null;
    situacao: string | null;
    aprovacoes: ViagemDespesaAprovacao[] = [];

    constructor(
        id = null,
        codigo = null,
        viagem: Viagem | null = null,
        tipo = null,
        dataDespesa = null,
        observacao = '',
        imagens: Arquivo[] = [],
        valor = 0,
        valorAlerta = null,
        situacao = null,
    ) {
        this.id = id;
        this.codigo = codigo;
        this.viagem = viagem;
        this.tipo = tipo;
        this.dataDespesa = dataDespesa;
        this.observacao = observacao;
        this.imagens = imagens;
        this.valor = valor;
        this.valorAlerta = valorAlerta;
        this.situacao = situacao;
    }

}